<script setup>
import { computed } from 'vue'
import { getSvgForPlatform } from '@/services/iconService.js'

const props = defineProps({
    link: { type: Object, required: true },
    platform: { type: String, required: true },
    fallbackIcon: { type: String, default: null },
    DoBucket: { type: String, default: '' },
    DoEndpoint: { type: String, default: '' },
})

const parsedOptions = computed(() => {
    const o = props.link?.options
    if (!o) return {}
    if (typeof o === 'string') { try { return JSON.parse(o) } catch { return {} } }
    return o
})

const iconDisplay = computed(() => parsedOptions.value?.icon_display || null)
const iconStyle = computed(() => parsedOptions.value?.icon_style || 'color')

const platformSvg = computed(() => {
    const type = iconStyle.value === 'mono' ? 'mono' : 'default'
    return getSvgForPlatform(props.platform, type)
})
</script>

<template>
    <div class="d-flex align-items-center" style="width:1.5rem; height:1.5rem; flex-shrink:0">
        <template v-if="iconDisplay === 'none'"></template>
        <template v-else-if="iconDisplay === 'thumbnail' && link.file">
            <img
                :src="`${DoEndpoint}/${DoBucket}/links/${link.file}`"
                :alt="platform"
                style="width:1.5rem; height:1.5rem; object-fit:cover; border-radius:4px"
            />
        </template>
        <template v-else-if="iconDisplay === 'platform' && platformSvg">
            <span
                style="width:1.5rem; height:1.5rem; display:flex; align-items:center;"
                v-html="platformSvg"
            ></span>
        </template>
        <template v-else-if="fallbackIcon">
            <img :src="fallbackIcon" :alt="platform" style="width:1.5rem; height:1.5rem" />
        </template>
    </div>
</template>
